import React from 'react'
import SoundList from './components/SoundList'
import OfflineIndicator from './components/OfflineIndicator'

function App() {
  return (
    <div className="app">
      <OfflineIndicator />
      <header className="app-header">
        <h1>Sound Board</h1>
      </header>
      <main className="app-main">
        <SoundList />
      </main>
    </div>
  )
}

export default App
